import styled from 'styled-components'
import Icon from './Icon'

const UsersIcon = styled(Icon).attrs({
  type: 'users',
})``

export default UsersIcon
